import { Component, Input } from '@angular/core'
import { HearingSegment } from '@ftr/contracts/type/court'
import { TimeRangeTextComponent } from '@ftr/forms'
import { TooltipModule } from '@ftr/foundation'

@Component({
  selector: 'ftr-complex-list-timeframes',
  templateUrl: './complex-list-timeframes.component.html',
  styleUrls: ['./complex-list-timeframes.component.css'],
  standalone: true,
  imports: [TooltipModule, TimeRangeTextComponent],
})
export class ComplexListTimeframesComponent {
  @Input() hearingSegments: HearingSegment[]
  @Input() isLive = false
}
